import { Component } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Observable } from 'rxjs/Observable';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { CfcService } from '../cfc.service';
import { Util } from '../../shared/util';

@Component({
  templateUrl: './analisar-credenciamento-cfc.component.html',
})
export class AnalisarCredenciamentoCfcComponent extends WebPage {

  uploadUrl: string;

  arquivosToRemove = new FormArray([]);
  labelAnalise;

  get isAprovado() { return this.form.get('isAprovado'); }
  get dataAnalise() { return this.form.get('dataAnalise'); }
  get dataValidadeCredenciamento() { return this.form.get('dataValidadeCredenciamento'); }
  get motivo() { return this.form.get('motivo'); }
  get arquivos() { return this.form.get('arquivos') as FormArray; }

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private arquivoService: ArquivoService,
    private cfcService: CfcService
  ) {
    super(messageService);

    this.route.paramMap
      .subscribe(params => {
        this.form = this.fb.group({
          idCfcUnidade: [ params.get('idCfcUnidade') ],
          isAprovado: [null, Validators.required],
          dataAnalise: [null, Validators.required],
          dataValidadeCredenciamento: [],
          numeroProcesso: [null, Validators.required],
          motivo: [],
          arquivos: new FormArray([])
        });
      });

    this.uploadUrl = this.arquivoService.uploadUrl + 'termoCredenciamento';
  }

  isAprovadoChanged(isAprovadoParam) {
    if (isAprovadoParam) {
      this.labelAnalise = 'Data de assinatura do termo de credenciamento';

      this.dataValidadeCredenciamento.setValidators(Validators.required);

      this.motivo.setValue(null);
      this.motivo.clearValidators();
    } else {
      this.labelAnalise = 'Data da Análise';

      this.motivo.setValidators(Validators.required);

      this.dataValidadeCredenciamento.setValue(null);
      this.dataValidadeCredenciamento.clearValidators();
    }

    this.dataValidadeCredenciamento.updateValueAndValidity();
    this.motivo.updateValueAndValidity();
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }

  downloadTermoCredenciamento(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Termo_Credenciamento_CFC');
  }

  submit() {
    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja enviar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);

        this.isLoading = true;
        this.cfcService.analisarCredenciamento(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            () => {
              localStorage.setItem('mensagem', 'Analisado');
              this.router.navigate(['/gerenciar-cfc']);
            },
            error => this.gerenciaErro(error)
        );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  // TODO isto pode ser um exit guard
  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-cfc']);
      }
    });
  }

  validaForm(): boolean {
    if (this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
      return false;
    }

    if (this.arquivos.length !== 1) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'É necessário carregar apenas 1 arquivo!' });
      return false;
    }

    if (this.isAprovado.value) {
      const diferencaDias = Util.calculaDiferencaDias(this.dataValidadeCredenciamento.value, this.dataAnalise.value);
      if (diferencaDias > 365) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Data de Validade do Credenciamento não pode ser superior a 1 ano a partir da Data de Análise.'
        });
        return false;
      }
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cfc/analisar-credenciamento-cfc/analisar-credenciamento-cfc.component.ts